(function() { module.exports = this["wp"]["date"]; }());